import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
    getCurrentUser, getHostDetails, getLoggedUserDetails, getLoginLogoutUserStatus,
    getloginupdatedstatus, getLogoutUserStatus, getUserProfilePic, loadUserDetails,
    loadUserProfilePic, loginLogoutStatusReceived, loginLogoutUpdateStatus,
    loginStatusUpdate, logoutCurrentUser, userLogoutStatusRecevied
} from "../../store/auth";
import ChangePassword from "../../../components/ChangePassword";
import Help from "../../../components/Anlytics/Help";
import SupportPupup from "../../../components/Anlytics/SupportPupup";
import { useDispatch, useSelector } from "react-redux";
import { getPageTitle, getWorkbenchHelpDocs, loadWorkbenchHelpDocs } from "../../store/layoutUI";
import AddSecurityQuestion from "../../../components/AddSecurityQuestion";
import PartnerProfile from "../../../components/PartnerManage/PartnerProfile";
import config from "../../../config.json";
import { PUBLIC_CLIENT_APPLICATION } from "../../../msalConfig";

const HEADER_FONT =
    'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';

const HEADER_STYLES = {
    shell: {
        background: "#ffffff",
        boxShadow: "0 14px 40px rgba(15, 23, 42, 0.08)",
        color: "#0f172a",
        overflow: "visible",
        position: "relative",
        width: "100%",
        borderBottom: "1px solid rgba(203, 213, 225, 0.85)",
        fontFamily: HEADER_FONT
    },
    topRow: {
        borderBottom: "1px solid rgba(203, 213, 225, 0.75)",
        position: "relative",
        zIndex: 5
    },
    brandRow: {
        display: "flex",
        alignItems: "flex-start",
        gap: "20px",
        marginBottom: "4px",
        flexWrap: "wrap"
    },
    brandLogo: {
        height: "84px",
        width: "auto",
        display: "block",
        backgroundColor: "#ffffff",
        padding: "4px 0",
    },
    profileCard: {
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "14px",
        width: "100%",
        minHeight: "84px",
        border: "1px solid rgba(203, 213, 225, 0.9)",
        background: "#ffffff",
        borderRadius: "0px",
        padding: "12px 14px",
        color: "#0f172a",
        backdropFilter: "blur(6px)",
        overflow: "visible",
        zIndex: 6
    },
    profileMain: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        minWidth: 0,
        flex: 1
    },
    avatar: {
        width: "50px",
        height: "50px",
        objectFit: "cover",
        borderRadius: "50%",
        border: "2px solid rgba(228, 236, 244, 0.45)",
    },
    userContent: {
        minWidth: 0,
        flex: 1
    },
    userName: {
        fontSize: "17px",
        fontWeight: 500,
        lineHeight: 1.2,
        marginBottom: "6px",
        color: "#0f172a"
    },
    detailRow: {
        display: "flex",
        flexWrap: "wrap",
        gap: "6px",
        marginBottom: "5px"
    },
    detailPill: {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "4px 8px",
        borderRadius: "0px",
        backgroundColor: "transparent",
        border: "1px solid rgba(203, 213, 225, 0.9)",
        fontSize: "11px",
        color: "#334155",
        fontWeight: 500,
        lineHeight: 1
    },
    dropdownButton: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        border: "none",
        background: "#e2e8f0",
        color: "#334155",
        width: "30px",
        height: "30px",
        padding: 0,
        borderRadius: "0px",
        cursor: "pointer"
    },
    darkBannerContainer: {
        background: 'rgba(12, 12, 14, 0.85) url("/assets/Img/slide3.jpg")',
        backgroundSize: "cover",
        backgroundPosition: "center",
        borderTop: "1px solid #333",
        position: "relative",
        zIndex: 1
    },
    quickRow: {
        background: "transparent",
        position: "relative",
        borderBottom: "1px solid rgba(255, 255, 255, 0.08)",
        margin: 0,
        zIndex: 1
    },
    quickInfoBlock: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        flexWrap: "wrap",
        minHeight: "40px"
    },
    portalBadge: {
        display: "inline-flex",
        alignItems: "center",
        borderRadius: "0px",
        border: "1px solid #374151",
        background: "#000000",
        padding: "7px 14px",
        fontSize: "14px",
        fontWeight: 500,
        letterSpacing: "0.01em",
        color: "#ffffff",
        fontFamily: HEADER_FONT,
        boxShadow: "0 2px 5px rgba(15, 23, 42, 0.08)",
        cursor: "pointer"
    },
    quickButton: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        borderRadius: "0px",
        border: "1px solid #374151",
        background: "#000000",
        color: "#ffffff",
        padding: "7px 14px",
        fontSize: "14px",
        fontWeight: 500,
        letterSpacing: "0.01em",
        lineHeight: 1.25,
        fontFamily: HEADER_FONT,
        marginTop: "0",
        cursor: "pointer",
        boxShadow: "0 2px 5px rgba(15, 23, 42, 0.08)",
        transition: "all 0.2s ease"
    },
    logoutButton: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        borderRadius: "0px",
        border: "1px solid #374151",
        background: "#000000",
        color: "#ffffff",
        padding: "7px 14px",
        fontSize: "14px",
        fontWeight: 500,
        letterSpacing: "0.01em",
        lineHeight: 1.25,
        fontFamily: HEADER_FONT,
        marginTop: "0",
        cursor: "pointer",
        boxShadow: "0 2px 5px rgba(220, 38, 38, 0.12)",
        transition: "all 0.2s ease"
    },
    actionWrap: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "10px"
    },
    dropdownContainer: {
        position: "relative",
        display: "inline-flex",
        alignItems: "center"
    },
    dropdownMenu: {
        position: "absolute",
        top: "calc(100% + 4px)",
        right: 0,
        minWidth: "220px",
        backgroundColor: "#ffffff",
        borderRadius: "0px",
        boxShadow: "0 8px 24px rgba(15, 23, 42, 0.12)",
        padding: "6px 0",
        border: "1px solid rgba(203, 213, 225, 0.9)",
        zIndex: 1000
    },
    dropdownItem: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        width: "100%",
        border: "none",
        background: "transparent",
        color: "#1e293b",
        textAlign: "left",
        padding: "10px 14px",
        borderRadius: "0px",
        fontSize: "14px",
        fontWeight: 500,
        cursor: "pointer"
    },
    toggleButton: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "32px",
        height: "32px",
        borderRadius: "0px",
        border: "1px solid #374151",
        background: "#000000",
        color: "#ffffff",
        fontSize: "13px",
        cursor: "pointer",
        transition: "all 0.2s ease",
    },
    titleSupport: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "10px",
        fontSize: "15px",
        fontWeight: 500,
        color: "#ffffff",
        letterSpacing: "0.02em",
        textAlign: "center",
        flex: 1
    },
    titleSupportWrap: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "8px 0",
        background: "transparent",
        color: "#ffffff",
        position: "relative",
        zIndex: 1
    },
    titleSupportAccent: {
        width: "22px",
        height: "1px",
        background: "rgba(255, 255, 255, 0.55)",
        flexShrink: 0
    },
};

const TopMenu = ({ headerVisible: propHeaderVisible, setHeaderVisible: propSetHeaderVisible }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const getWorkplaceLabel = () => {
        const path = location.pathname;
        let wp = localStorage.getItem("selectedWorkplace");

        if (path === "/onboarding-hexagon") wp = "onboarding";
        else if (path === "/recruitment-hexagon") wp = "recruitment";
        else if (path === "/safety-hexagon") wp = "safety";

        if (wp === "recruitment") return "Recruitment";
        if (wp === "onboarding") return "Onboarding";
        if (wp === "safety") return "Safety Management";
        if (wp === "admin") return "System Administration";

        return "Onboarding";
    };
    const [showHide, setShowHide] = useState(false);
    const [helpShowHide, setHelpShowHide] = useState(false);
    const [issueShowHide, setIssueShowHide] = useState(false);
    const [securityShowHide, setSecurityShowHide] = useState(false);
    const [profileShowHide, setProfileShowHide] = useState(false);
    const [userDetails, setUserDetails] = useState(null);
    const [profilePicData, setProfilePicData] = useState(null);
    const [firstLogin, setFirstLogin] = useState(false);
    const [helpDocs, setHelpDocs] = useState(null);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [logoutProcess, setLogoutProcess] = useState(false);
    const [localHeaderVisible, setLocalHeaderVisible] = useState(true);

    const headerVisible = propHeaderVisible !== undefined ? propHeaderVisible : localHeaderVisible;
    const setHeaderVisible = propSetHeaderVisible !== undefined ? propSetHeaderVisible : setLocalHeaderVisible;

    const dropdownRef = useRef(null);

    const pageTitleSelector = useSelector(getPageTitle);
    const loggedUserDetailsSelector = useSelector(getLoggedUserDetails);
    const userProfilePicSelector = useSelector(getUserProfilePic);
    const userLoginSelector = useSelector(getloginupdatedstatus);
    const workbenchHelpDocsSelector = useSelector(getWorkbenchHelpDocs);
    const hostDetailsSelector = useSelector(getHostDetails);
    const logoutUserStatusSelector = useSelector(getLogoutUserStatus);
    const loginLogoutUserStatusSelector = useSelector(getLoginLogoutUserStatus);

    const dispatch = useDispatch();
    const currentUser = getCurrentUser();

    useEffect(() => {
        if (currentUser?.id) {
            dispatch(loadUserDetails(currentUser.id));
            dispatch(loadUserProfilePic(currentUser.id));
            dispatch(loadWorkbenchHelpDocs(config.HelpDocIds.adminDoc));
        }
    }, []);

    useEffect(() => {
        if (workbenchHelpDocsSelector) {
            setHelpDocs(workbenchHelpDocsSelector);
        }
    }, [workbenchHelpDocsSelector]);

    useEffect(() => {
        if (loggedUserDetailsSelector) {
            if (loggedUserDetailsSelector?.maxtasks === null) {
                dispatch(loginStatusUpdate(currentUser.id));
                setFirstLogin(true);
                setSecurityShowHide(true);
            } else {
                setFirstLogin(false);
            }
            setUserDetails(loggedUserDetailsSelector);
        }
    }, [loggedUserDetailsSelector]);

    useEffect(() => {
        if (userProfilePicSelector) {
            setProfilePicData(
                process.env.REACT_APP_API_BASEURL + "/ProfilePics/" + userProfilePicSelector
            );
        }
    }, [userProfilePicSelector]);

    useEffect(() => {
        setLogoutProcess(false);
        if (logoutUserStatusSelector) {
            dispatch(loginLogoutStatusReceived(false));
            window.location = "/login";
        }
        if (loginLogoutUserStatusSelector) {
            dispatch(loginLogoutStatusReceived(false));
            window.location = "/login";
        }
    }, [logoutUserStatusSelector, loginLogoutUserStatusSelector]);

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, []);

    const handleModalShowHide = () => {
        setShowHide((prev) => !prev);
    };

    const handleHelpShowHide = () => {
        setHelpShowHide((prev) => !prev);
    };

    const handleIssueShowHide = () => {
        setIssueShowHide((prev) => !prev);
    };

    const handleSecurityShowHide = () => {
        setSecurityShowHide((prev) => !prev);
        setIsDropdownOpen(false);
    };

    const handleProfileShowHide = () => {
        setProfileShowHide((prev) => !prev);
        setIsDropdownOpen(false);
    };

    const handleLogout = async () => {
        setLogoutProcess(true);
        const hostId = localStorage.getItem("hostId");
        localStorage.removeItem("token");
        if (hostId && currentUser?.id) {
            dispatch(logoutCurrentUser(currentUser.id, hostId));
        } else {
            await PUBLIC_CLIENT_APPLICATION.logoutPopup();
            window.location = "/login";
        }
        localStorage.clear();
        sessionStorage.clear();
        if (currentUser?.id) {
            dispatch(loginLogoutUpdateStatus(currentUser.id));
        }
    };

    const getPortalLabel = () => {
        return "Workbench Portal";
    };

    const getUserDisplayName = () => {
        return currentUser?.name || "Portal User";
    };

    const getRoleLabel = () => {
        return userDetails?.role || "User";
    };

    const getLastLoginLabel = () => {
        return new Date().toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric"
        });
    };

    const handleCurrentTask = async () => { };
    const handleWorkflowTask = () => { };

    const dropdownActionStyle = (isDanger) => ({
        ...HEADER_STYLES.dropdownItem,
        color: isDanger ? "#b91c1c" : "#1e293b"
    });

    const profileImage = profilePicData || "../../assets/img/theme/team-4.png";

    return (
        <>
            <style>{`
                .topmenu-action-btn,
                .topmenu-logout-btn {
                    font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
                    font-size: 14px !important;
                    font-weight: 500 !important;
                }
                .topmenu-action-btn,
                .topmenu-logout-btn,
                .topmenu-action-btn i,
                .topmenu-logout-btn i {
                    background-color: #000000 !important;
                    color: #ffffff !important;
                }
                .topmenu-action-btn:hover,
                .topmenu-action-btn:focus,
                .topmenu-logout-btn:hover,
                .topmenu-logout-btn:focus {
                    background-color: #1f2937 !important;
                    border-color: #4b5563 !important;
                    color: #ffffff !important;
                }
                .topmenu-action-btn:hover i,
                .topmenu-action-btn:focus i,
                .topmenu-logout-btn:hover i,
                .topmenu-logout-btn:focus i {
                    background-color: transparent !important;
                    color: #ffffff !important;
                }
                .topmenu-dropdown-item {
                    transition: background-color 0.15s ease;
                }
                .topmenu-dropdown-item:hover {
                    background-color: #f1f5f9 !important;
                }
            `}</style>
            <div className="w-100 px-0">
                <div style={HEADER_STYLES.shell}>
                    <div className="align-items-center" style={HEADER_STYLES.topRow}>
                        {headerVisible && (
                            <div className="row pt-2 pb-2 mx-0 px-3" style={{ background: "#ffffff" }}>
                                <div className="col-lg-7 col-md-12 px-0">
                                    <div style={HEADER_STYLES.brandRow}>
                                        <img
                                            src="/assets/Img/logo.png"
                                            alt="Portal logo"
                                            style={HEADER_STYLES.brandLogo}
                                        />
                                    </div>
                                </div>

                                <div className="col-lg-5 col-md-12 px-0">
                                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                        <div style={HEADER_STYLES.profileCard}>
                                            <div style={HEADER_STYLES.profileMain}>
                                                <img
                                                    alt="Profile"
                                                    src={profileImage}
                                                    style={HEADER_STYLES.avatar}
                                                />
                                                <div style={HEADER_STYLES.userContent}>
                                                    <div style={HEADER_STYLES.userName}>{getUserDisplayName()}</div>
                                                    <div style={HEADER_STYLES.detailRow}>
                                                        <span style={HEADER_STYLES.detailPill}>
                                                            <i className="fa fa-id-badge" aria-hidden="true"></i>
                                                            Reg ID: {currentUser?.id || "-"}
                                                        </span>
                                                        <span style={HEADER_STYLES.detailPill}>
                                                            <i className="fa fa-briefcase" aria-hidden="true"></i>
                                                            Role: {getRoleLabel()}
                                                        </span>
                                                        <span style={HEADER_STYLES.detailPill}>
                                                            <i className="fa fa-clock-o" aria-hidden="true"></i>
                                                            Last Login: {getLastLoginLabel()}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div ref={dropdownRef} style={HEADER_STYLES.dropdownContainer}>
                                                <button
                                                    type="button"
                                                    aria-label="Open profile actions"
                                                    aria-expanded={isDropdownOpen}
                                                    onClick={() => setIsDropdownOpen((prev) => !prev)}
                                                    style={HEADER_STYLES.dropdownButton}
                                                >
                                                    <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
                                                </button>

                                                {isDropdownOpen && (
                                                    <div style={HEADER_STYLES.dropdownMenu}>
                                                        <button
                                                            type="button"
                                                            className="topmenu-dropdown-item"
                                                            style={dropdownActionStyle(false)}
                                                            onClick={handleProfileShowHide}
                                                        >
                                                            <i className="fa fa-user-circle-o" aria-hidden="true"></i>
                                                            <span>My Profile</span>
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="topmenu-dropdown-item"
                                                            style={dropdownActionStyle(false)}
                                                            onClick={() => {
                                                                setIsDropdownOpen(false);
                                                                handleModalShowHide();
                                                            }}
                                                        >
                                                            <i className="fa fa-lock" aria-hidden="true"></i>
                                                            <span>Change Password</span>
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="topmenu-dropdown-item"
                                                            style={dropdownActionStyle(false)}
                                                            onClick={handleSecurityShowHide}
                                                        >
                                                            <i className="fa fa-shield" />
                                                            <span>Security Questions</span>
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="topmenu-dropdown-item"
                                                            style={dropdownActionStyle(false)}
                                                            onClick={() => {
                                                                setIsDropdownOpen(false);
                                                                handleHelpShowHide();
                                                            }}
                                                        >
                                                            <i className="fa fa-question-circle"></i>
                                                            <span>Help Center</span>
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="topmenu-dropdown-item"
                                                            style={dropdownActionStyle(true)}
                                                            onClick={handleLogout}
                                                            disabled={logoutProcess}
                                                        >
                                                            <i className={logoutProcess ? "fa fa-spinner fa-spin" : "ni ni-user-run"} />
                                                            <span>{logoutProcess ? "Signing out..." : "Logout"}</span>
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        <div style={HEADER_STYLES.darkBannerContainer} className="px-3">
                            <div style={HEADER_STYLES.quickRow} className="row pt-2 pb-2 mx-0">
                                <div style={HEADER_STYLES.quickInfoBlock} className="col-4 px-0">
                                    <button
                                        type="button"
                                        className="topmenu-action-btn"
                                        onClick={() => navigate("/onboarding-hexagon")}
                                        style={HEADER_STYLES.portalBadge}
                                    >
                                        {getPortalLabel()}
                                    </button>
                                </div>
                                <div style={HEADER_STYLES.actionWrap} className="col-8 px-0">
                                    <button
                                        type="button"
                                        className="topmenu-action-btn"
                                        onClick={() => navigate("/workplaces")}
                                        style={HEADER_STYLES.quickButton}
                                    >
                                        <i className="fa fa-th-large" aria-hidden="true"></i>
                                        Switch Workplace
                                    </button>
                                    <button
                                        type="button"
                                        className="topmenu-action-btn"
                                        onClick={handleIssueShowHide}
                                        title="Any defects/issues found in the portal can be registered in the customer support portal."
                                        style={HEADER_STYLES.quickButton}
                                    >
                                        <i className="fa fa-life-ring" aria-hidden="true"></i>
                                        Customer Support
                                    </button>
                                    <button
                                        type="button"
                                        className="topmenu-action-btn"
                                        onClick={handleHelpShowHide}
                                        style={HEADER_STYLES.quickButton}
                                    >
                                        <i className="fa fa-question-circle" aria-hidden="true"></i>
                                        Help
                                    </button>
                                    <button
                                        type="button"
                                        className="topmenu-logout-btn"
                                        onClick={handleLogout}
                                        disabled={logoutProcess}
                                        style={HEADER_STYLES.logoutButton}
                                    >
                                        <i className={logoutProcess ? "fa fa-spinner fa-spin" : "ni ni-user-run"} />
                                        {logoutProcess ? "Signing out..." : "Logout"}
                                    </button>
                                </div>
                            </div>

                            <div style={HEADER_STYLES.titleSupportWrap}>
                                <div style={{ width: "32px" }}></div>
                                <div style={HEADER_STYLES.titleSupport}>
                                    <span style={{ color: "#ffffff", fontWeight: 500, fontSize: "14px" }}>
                                        Human Resources Information Management System (HRIMS)
                                    </span>
                                    <span style={{ color: "rgba(255, 255, 255, 0.4)", margin: "0 6px" }}>-</span>
                                    <div style={{
                                        background: "#000000",
                                        border: "1px solid #374151",
                                        borderRadius: "0px",
                                        padding: "4px 12px",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.18)"
                                    }}>
                                        <div style={{
                                            width: "7px",
                                            height: "7px",
                                            borderRadius: "50%",
                                            background: "#ffffff",
                                            boxShadow: "0 0 0 2px rgba(255, 255, 255, 0.18)"
                                        }}></div>
                                        <span style={{
                                            fontSize: "11px",
                                            fontWeight: "500",
                                            color: "#ffffff",
                                            textTransform: "uppercase",
                                            letterSpacing: "0.5px"
                                        }}>
                                            {getWorkplaceLabel()}
                                        </span>
                                    </div>
                                </div>
                                <div>
                                    <button
                                        type="button"
                                        onClick={() => setHeaderVisible(!headerVisible)}
                                        title={headerVisible ? "Hide Header" : "Show Header"}
                                        style={HEADER_STYLES.toggleButton}
                                    >
                                        <i className={`fa fa-chevron-${headerVisible ? "up" : "down"}`} aria-hidden="true"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {showHide && (
                    <ChangePassword
                        handleModalShowHide={handleModalShowHide}
                        showHide={showHide}
                    ></ChangePassword>
                )}
                {profileShowHide && (
                    <PartnerProfile
                        handleProfileShowHide={handleProfileShowHide}
                        profileShowHide={profileShowHide}
                    ></PartnerProfile>
                )}
                {helpShowHide && (
                    <Help
                        helpShowHide={helpShowHide}
                        handleHelpShowHide={handleHelpShowHide}
                        module={pageTitleSelector}
                        helpDocs={helpDocs}
                    ></Help>
                )}
                {issueShowHide && (
                    <SupportPupup
                        handleIssueShowHide={handleIssueShowHide}
                        issueShowHide={issueShowHide}
                        handleCurrentTask={handleCurrentTask}
                        handleWorkflowTask={handleWorkflowTask}
                    ></SupportPupup>
                )}

                {securityShowHide && (
                    <AddSecurityQuestion
                        firstLogin={firstLogin}
                        securityShowHide={securityShowHide}
                        handleSecurityShowHide={handleSecurityShowHide}
                        userDetails={userDetails}
                        handleLogout={handleLogout}
                    ></AddSecurityQuestion>
                )}
            </div>
        </>
    );
};

export default TopMenu;
